import { State, get_state } from '../../redux/State'
import { Keys } from '../../redux/Datastore'
import { cms_logging } from '../../cms_logging';
import { Actions } from "../../redux/Actions"

export function draw_pushpin_menu(): void {
    if (!get_state().enabled_feature_spotshadow) {
        // spotshadow is not enabled. do nothing
        return;
    }
    // mark the selected bulding
    let li: HTMLLIElement = <HTMLLIElement>document.getElementById('menu_pushpin_content_list_item');
    let a: HTMLAnchorElement = <HTMLAnchorElement>document.getElementById('pushpin_menu_select');
    if (get_state().get_boolean(Keys.KEY_MENU_PUSHPIN_SELECTED)) {
        li.classList.add("selected");
        a.text = "Remove Spot Shadow";

    }
    else {
        li.classList.remove("selected")
        a.text = "Set Spot Shadow";
    }
}

export function remove_pushpin_menu_item(): void {
    let div: HTMLDivElement = <HTMLDivElement>document.getElementById('menu_pushpin_content1');
    if (div) {
        div.style.display = "none";
    }
}

export function show_pushpin_menu_item(): void {
    let div: HTMLDivElement = <HTMLDivElement>document.getElementById('menu_pushpin_content1');
    if (div) {
        div.style.display = "block";
    }
}

export function toggle_pushpin_layer(dispatch: any): void {
    let enabled: boolean = true;
    let anchor: HTMLAnchorElement = <HTMLAnchorElement>document.getElementById('pushpin_menu_select');
    let li: HTMLLIElement = <HTMLLIElement>document.getElementById("menu_pushpin_content_list_item");
    let selected_in_ui: boolean = li.hasAttribute("selected");
    enabled = !selected_in_ui;
    dispatch(Actions.ACTION_SET_MENU_PUSHPIN_SELECTED, enabled);
    if (enabled) {
        dispatch(Actions.ACTION_SET_PUSHPIN_GET_COORD_START, null);
    }
    else {
        dispatch(Actions.ACTION_REMOVE_PUSHPIN_COORD, null);
    }
}




// WEBPACK FOOTER //
// ./src/ts/ui/menu/PushpinMenu.ts